import { render, staticRenderFns } from "./BrowseContextMenu.vue?vue&type=template&id=b82e3222&scoped=true"
import script from "./BrowseContextMenu.vue?vue&type=script&lang=ts"
export * from "./BrowseContextMenu.vue?vue&type=script&lang=ts"
import style0 from "./BrowseContextMenu.vue?vue&type=style&index=0&id=b82e3222&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b82e3222",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b82e3222')) {
      api.createRecord('b82e3222', component.options)
    } else {
      api.reload('b82e3222', component.options)
    }
    module.hot.accept("./BrowseContextMenu.vue?vue&type=template&id=b82e3222&scoped=true", function () {
      api.rerender('b82e3222', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/browse/BrowseContextMenu.vue"
export default component.exports